import React, { Component } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";

import Header from "./components/Header.js";
import Main from "./components/Main.js";

import "./App.css";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      darkMode: false,
    };
  }

  componentDidMount() {
    const savedMode = localStorage.getItem("darkMode") === "true";
    this.setState({ darkMode: savedMode });
  }

  toggleDarkMode = () => {
    this.setState((prevState) => {
      const newMode = !prevState.darkMode;
      localStorage.setItem("darkMode", newMode);
      return { darkMode: newMode };
    });
  };

  render() {
    const { darkMode } = this.state;

    const theme = createMuiTheme({
      palette: {
        type: darkMode ? "dark" : "light",
      },
      typography: {
        fontSize: 16,
        fontFamily:
          '"Jost", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
      },
    });

    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app-content">
          <Router>
            <Header toggleDarkMode={this.toggleDarkMode} darkMode={darkMode} />
            <Main />
          </Router>
        </div>
      </ThemeProvider>
    );
  }
}

export default App;
